import React from 'react';
import cn from 'classnames';
import { FloatingPortal } from '@floating-ui/react';
import { idxMap } from 'helpers/styleMapIdx';

import styles from './Popover.module.scss';

const PLACEMENTS = {
  'right-end': styles.popoverRightEnd,
  'left-end': styles.popoverLeftEnd,
  'bottom-start': styles.popoverBottomStart,
};

const Popover = ({
  className,
  triggerClassName,
  isHover,
  isMounted,
  refs,
  animationStyles,
  styleProps,
  mode,
  placement,
  triggerElement,
  children,
  getReferenceProps,
  getFloatingProps,
}: {
  className: any;
  triggerClassName: any;
  isHover?: boolean;
  isMounted: any;
  refs: any;
  animationStyles: any;
  styleProps: any;
  mode: any;
  placement: any;
  triggerElement: any;
  children: any;
  getReferenceProps: any;
  getFloatingProps: any;
}) => {
  const popoverContent = isMounted ? (
    <div
      className={cn(
        styles.popover,
        idxMap(PLACEMENTS as Record<string, string>, placement),
        className,
      )}
      ref={refs.setFloating}
      style={{
        ...styleProps,
        ...animationStyles,
        pointerEvents: isHover ? 'auto' : undefined,
      }}
      {...getFloatingProps()}
    >
      {children}
    </div>
  ) : null;

  return (
    <>
      <div
        className={cn(styles.trigger, triggerClassName)}
        ref={refs.setReference}
        {...getReferenceProps({
          onClick: (event: any) => event.stopPropagation(),
        })}
      >
        {triggerElement({ isMounted })}
      </div>
      <FloatingPortal>{popoverContent}</FloatingPortal>
    </>
  );
};

export default React.memo(Popover) as any;
